

exports.__esModule = true;
exports.$xoEConsentPageRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoEConsentPageRoute = exports.$xoEConsentPageRoute = _index.$Route.extend('$xoEConsentPageRoute', {

    path: 'econsent',
    directive: _directive2['default'],
    titleContent: 'eConsent.title',

    trackingData: {
        fptiState: 'econsent',
        templateName: 'eConsent.dust',
        pageGoal: 'eConsent',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-econsent',
                'pagename2': '%::fullpage-econsent:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: []
});

angular.value("$xoEConsentPageRoute", $xoEConsentPageRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-eConsent/route.js
// module id = ./pages/xo-eConsent/route.js
// module chunks = 0